.channelStatistics {
  max-width: 420px;
}

.title {
  margin-bottom: 1rem;
}

.statsRow {
  display: flex;
  justify-content: space-between;
}

.statsText {
  font-weight: var(--font-weight-light);
}

.statsNumber {
  width: 75px;
  font-weight: var(--font-weight-light);
}

.divider {
  height: 1px;
  margin-bottom: 0.25rem;
  border-color: black;
  border-width: 0.5px;
}
